import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
var ScrollPositions = {
  BOTTOM: 'bottom',
  MIDDLE: 'middle',
  TOP: 'top'
};
export var ScrollHelper = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollHelper, _React$Component);

  var _super = _createSuper(ScrollHelper);

  function ScrollHelper(props) {
    var _this;

    _classCallCheck(this, ScrollHelper);

    _this = _super.call(this, props);

    _this.handleScroll = function (_ref) {
      var target = _ref.target;

      if (_this.helper !== target) {
        return;
      }

      var scrollTop = target.scrollTop;
      var nextPosition = null;

      if (scrollTop === _this.helper.scrollHeight - _this.helper.clientHeight) {
        nextPosition = ScrollPositions.BOTTOM;
      } else if (scrollTop === 0) {
        nextPosition = ScrollPositions.TOP;
      } else {
        nextPosition = ScrollPositions.MIDDLE;
      }

      if (typeof _this.props.onScrollTo === 'function' && !(nextPosition === ScrollPositions.MIDDLE && _this.position === ScrollPositions.MIDDLE)) {
        _this.props.onScrollTo(nextPosition);
      }

      _this.position = nextPosition;
    };

    _this.adjustScrollTop = function () {
      if (_this.position === ScrollPositions.BOTTOM) {
        _this.scrollToBottom();
      } else if (_this.position === ScrollPositions.TOP) {
        _this.helper.scrollTop = Math.max(0, _this.helper.scrollHeight - _this.lastScrollHeight);
      }

      _this.lastScrollHeight = _this.helper.scrollHeight;
    };

    _this.componentDidMount = function () {
      return _this.adjustScrollTop();
    };

    _this.componentDidUpdate = function () {
      return _this.adjustScrollTop();
    };

    _this.scrollToBottom = function () {
      _this.helper.scrollTop = _this.helper.scrollHeight - _this.helper.clientHeight;
    };

    _this.render = function () {
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this.helper = el;
        },
        onScroll: _this.handleScroll,
        className: "discussion-messages-wrapper"
      }, _this.props.children);
    };

    _this.position = ScrollPositions.BOTTOM;
    return _this;
  }

  return ScrollHelper;
}(React.Component);